import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangelogService } from './services/changelog.service';

export interface AppConfig {
  name: string;
  version: string;
}

@NgModule({
  imports: [CommonModule],
  declarations: [],
  providers: [ChangelogService],
  exports: [],
})
export class ChangelogModule {
  static forRoot(appConfig: AppConfig): ModuleWithProviders<ChangelogModule> {
    return {
      ngModule: ChangelogModule,
      providers: [{ provide: 'appConfig', useValue: appConfig }],
    };
  }
}
